import { useEffect, useState } from "react";
import api from "@/lib/api";

let cached = null;
let inFlight = null;
const listeners = new Set();

function fetchOnce() {
  if (cached) return Promise.resolve(cached);
  if (inFlight) return inFlight;
  inFlight = api
    .get("/settings/public")
    .then((r) => {
      cached = r.data || {};
      inFlight = null;
      listeners.forEach((cb) => cb(cached));
      return cached;
    })
    .catch(() => {
      cached = {
        site_title: "School Dial", site_description: "",
        site_logo_url: "", site_favicon_url: "",
        seo_title_template: "Top 10 Schools in {city_name} {year}",
        seo_meta_template: "Best Schools in {city_name} {year} – Compare top nearby schools, fees, admissions and reviews.",
        city_desc_template: "Looking for admissions in {city_name} for the session {year}? Here is the complete list of top schools with fees, board, reviews and admission status.",
        default_year: "2026-27",
      };
      inFlight = null;
      listeners.forEach((cb) => cb(cached));
      return cached;
    });
  return inFlight;
}

function applyDocumentBranding(b) {
  if (!b) return;
  // Note: document.title is NOT set here — each page uses usePageMeta to set its own title.
  // Only favicon is applied globally.
  if (b.site_favicon_url) {
    let link = document.querySelector('link[rel="icon"]');
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    link.href = b.site_favicon_url;
  }
}

export default function useBranding() {
  const [b, setB] = useState(cached);
  useEffect(() => {
    let mounted = true;
    fetchOnce().then((data) => { if (mounted) { setB(data); applyDocumentBranding(data); } });
    const cb = (data) => { if (mounted) { setB(data); applyDocumentBranding(data); } };
    listeners.add(cb);
    return () => { mounted = false; listeners.delete(cb); };
  }, []);
  return b || { site_title: "School Dial", site_logo_url: "", site_favicon_url: "" };
}

// Allow SuperSettings to bust cache after saving
export function refreshBranding() {
  cached = null;
  return fetchOnce();
}

/**
 * Replace {city_name} and {year} placeholders in a template.
 * Extra placeholders can be passed via `extras`.
 */
export function fillTemplate(template, cityName, year, extras = {}) {
  if (!template) return "";
  const map = { city_name: cityName || "", year: year || "", ...extras };
  return template.replace(/\{(\w+)\}/g, (_, k) => (map[k] ?? "").toString());
}
